import { ReactNode, useMemo } from 'react'

import {
  OrganisationProfileCountry,
  OrganisationProfileLinks,
  RenderOrganisationProfileLink,
} from '../types/organisationProfile.types'
import {
  OrganisationProfileContext,
  OrganisationProfileService,
} from './OrganisationProfileContext'

const NO_COUNTRIES: OrganisationProfileCountry[] = []
const NO_LINKS: OrganisationProfileLinks = {}

export type OrganisationProfileProviderProps = {
  service: OrganisationProfileService
  locale?: string
  // The host's own country list, so filters match the rest of the app.
  countries?: OrganisationProfileCountry[]
  // Where the host's own pages live (e.g. PD's /verifications/:id); omitted links are hidden.
  links?: OrganisationProfileLinks
  // Renders links with the host's router; defaults to a plain Lemonade Anchor.
  renderLink?: RenderOrganisationProfileLink
  children: ReactNode
}

export function OrganisationProfileProvider({
  service,
  locale = 'en-US',
  countries = NO_COUNTRIES,
  links = NO_LINKS,
  renderLink,
  children,
}: Readonly<OrganisationProfileProviderProps>) {
  const value = useMemo(
    () => ({ service, locale, countries, links, renderLink }),
    [service, locale, countries, links, renderLink]
  )

  return (
    <OrganisationProfileContext.Provider value={value}>
      {children}
    </OrganisationProfileContext.Provider>
  )
}
